export const zohoConnectEnUS = {
  connectionSuccess: 'Zoho connected successfully',
}

export const zohoConnectEsMX = {
  connectionSuccess: 'Zoho fue conectado con éxito',
}
